module.exports = __webpack_public_path__ + "images/emoji/rage3.ba38f5caeb38b8390483.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rage3.png
// module id = NFLo
// module chunks = 24